module.exports = __webpack_public_path__ + "static/media/trimex_guadalupana.8d32b906.png";